import { useState } from 'react';
import msgIcon from '../../../assets/images/message-notif.svg';
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { Input, Typography } from 'antd';
import AttentionModal from '../../../components/attention-modal/AttentionModal';
import { onboardingApiV2 } from '../../../common/api/services/OnboardingApi/onboardingApiV2';
import { useParams } from 'react-router-dom';
import { changeNote } from '../../../redux/reducers/onboarding/sliceReducer';
import { openErrorNotification, openSuccessNotification } from '../../../components/notification/Notification';

const EditNote = () => {
    const dispatch = useAppDispatch();
    const { note } = useAppSelector((state) => state.onboarding);
    const { consultantId } = useParams<{ consultantId: string }>();
    const [isEditMode, setIsEditMode] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [isOpenConfirm, setIsOpenConfirm] = useState(false);

    const onSubmit = (clear?: boolean) => {
        if (!consultantId) {
            return;
        }
        if (inputValue.length > 100) {
            openErrorNotification('No more than 100 characters');
            return;
        }
        onboardingApiV2
            .updateEditNote(consultantId, clear ? '' : inputValue)
            .then(() => {
                dispatch(changeNote(clear ? '' : inputValue));
                setIsEditMode(false);
                setIsOpenConfirm(false);
                openSuccessNotification('The note was changed successfully');
            })
            .catch((e) => {
                openErrorNotification(e?.response?.data?.message);
            });
    };
    return (
        <div className="edit-note-container">
            <div className="edit-note-wrapper-no-cursor">
                {isEditMode ? (
                    <>
                        <Input
                            value={inputValue}
                            onChange={(e) => {
                                if (e.target.value.length > 100) {
                                    return;
                                }
                                setInputValue(e.target.value);
                            }}
                            style={{
                                backgroundColor: '#fff0e6',
                                border: '3px solid #2e71e0',
                                borderRadius: '5px',
                                width: '830px',
                            }}
                        />
                        <Typography.Text>{inputValue.length}/100</Typography.Text>
                    </>
                ) : (
                    <>
                        <img src={msgIcon} alt="" style={{ width: '20px', height: '20px' }} />
                        <Typography.Text>
                            <pre style={{ background: 'inherit' }}>{note || 'write note here...'}</pre>
                        </Typography.Text>
                    </>
                )}
            </div>
            <div className="edit-note-wrapper" style={{ gap: '20px' }}>
                {isEditMode ? (
                    <div onClick={() => onSubmit()} className="edit-note-wrapper" style={{ color: '#009262' }}>
                        <CheckOutlined />
                        Confirm
                    </div>
                ) : (
                    <div
                        onClick={() => {
                            setInputValue(note);
                            setIsEditMode(true);
                        }}
                        className="edit-note-wrapper"
                        style={{ color: '#f96800' }}
                    >
                        <EditOutlined />
                        Edit note
                    </div>
                )}
                {isEditMode ? (
                    <div
                        style={{ color: '#c93c31' }}
                        className="edit-note-wrapper"
                        onClick={() => {
                            setInputValue(note);
                            setIsEditMode(false);
                        }}
                    >
                        <CloseOutlined />
                        Cancel
                    </div>
                ) : (
                    <div
                        onClick={() => setIsOpenConfirm(true)}
                        className="edit-note-wrapper"
                        style={{ color: '#c93c31' }}
                    >
                        <DeleteOutlined />
                        Clear note
                    </div>
                )}
            </div>
            {isOpenConfirm && (
                <AttentionModal
                    content={
                        <Typography.Text style={{ fontSize: '18px' }}>
                            Are you sure that you want to clear this note?
                        </Typography.Text>
                    }
                    cancelBtnTitle="Cancel"
                    closeModal={() => setIsOpenConfirm(false)}
                    confirmBtnTitle="Clear"
                    isOpen={isOpenConfirm}
                    isHideAttentionText
                    confirmAction={() => onSubmit(true)}
                />
            )}
        </div>
    );
};

export default EditNote;
